<template>
<div class="tcjs-spinner">
    <div v-for="i in 4" :key="i" :style="{background: colors.text}">
    </div>
</div>
</template>
<script>
export default {
    name: 'Spinner',
    props: ['colors']
}
</script>
<style>
.tcjs-spinner {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 16px;
    margin: -4px 0px -1px 0px;
    opacity: 0.7;
}

.tcjs-spinner div {
    position: absolute;
    top: 8px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    animation-timing-function: cubic-bezier(1, 1, 1, 1);
}

.tcjs-spinner div:nth-child(1) {
    left: 2px;
    animation: tcjs-spinner1 0.6s infinite;
    opacity: 0.9;
}

.tcjs-spinner div:nth-child(2) {
    left: 2px;
    animation: tcjs-spinner2 0.6s infinite;
}

.tcjs-spinner div:nth-child(3) {
    left: 9px;
    animation: tcjs-spinner2 0.6s infinite;
}

.tcjs-spinner div:nth-child(4) {
    left: 16px;
    animation: tcjs-spinner3 0.6s infinite;
    opacity: 0.9;
}

@keyframes tcjs-spinner1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes tcjs-spinner3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes tcjs-spinner2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(7px, 0);
    }
}
</style>
